import { BaseEntity } from "yt-ng-framework";
import { EOtpremnicaPrevoz } from "../eotpremnica/eotpremnica-prevoz";

export class EPrijemnicaPrevoz extends EOtpremnicaPrevoz{
    constructor(){
        super();
    }   

     Deserialize(input:any){  
        super.Deserialize(input);
        return this;
    }
        Serialize(input:EPrijemnicaPrevoz){
        return input;
    }
}